import React from "react";
import { Box, Link } from "@mui/material";
import { FaYoutube } from "react-icons/fa";
import CustomSwitch from "shared/components/Switch/CustomSwitch";
import { useStyles } from "../styles/ConfigurarBuscaNFEmailStyles";

interface ConfiguracaoHeaderHeaderProps {
  isInsideWizard: boolean;
  checked: boolean;
  isEmailUnico: boolean;
  setShowModalEmailUnico: (show: boolean) => void;
  setShowModalAcessoADM: (show: boolean) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const ConfiguracaoHeader: React.FC<ConfiguracaoHeaderHeaderProps> = ({
  isInsideWizard,
  checked,
  onChange,
  isEmailUnico,
  setShowModalEmailUnico,
  setShowModalAcessoADM,
}) => {
  const classes = useStyles();

  if (isInsideWizard) {
    return (
      <Box className={classes.header}>
        <Box className={classes.titleContainer}>
          <Box className={classes.titleWrapper}>
            <h2 className={classes.wizardTitle}>3. Configuração de busca de NF por e-mail</h2>
            <span className={classes.headerPipe}>|</span>
            <Box className={classes.headerLinkContainer}>
              <Link
                onClick={() => (isEmailUnico ? setShowModalEmailUnico(true) : setShowModalAcessoADM(true))}
                className={classes.headerLink}
              >
                <FaYoutube size={18} />
                {isEmailUnico ? "Ver sobre o e-mail único" : "Veja sobre o acesso ao e-mail"}
              </Link>
            </Box>
          </Box>
          <p className={classes.subtitle}>
            Selecione a busca desejada. Essa configuração{" "}
            <strong>vale para todos os condomínios da administradora</strong> que usam o Group Pay.
          </p>
        </Box>
        <Box className={classes.toggleWrapper}>
          <CustomSwitch
            usarValidacaoParaFormulario={false}
            checked={checked}
            onChange={onChange}
            labelDireito={checked ? "Quero usar a busca por e-mail" : "Não quero usar a busca por e-mail"}
          />
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Box className={classes.header}>
        <Box className={classes.titleContainer}>
          <h2 className={classes.standaloneTitle}>Consulta de notas fiscais por e-mail</h2>
          <p className={classes.subtitle}>
            Essa configuração vale para todos os condomínios da administradora que usam o Group Pay.
          </p>
        </Box>
        <CustomSwitch
          usarValidacaoParaFormulario={false}
          checked={checked}
          onChange={onChange}
          labelDireito={checked ? "Ativo" : "Desativado"}
        />
      </Box>
    </>
  );
};

export default ConfiguracaoHeader;
